import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pie',
  templateUrl: './pie.component.html',
  styleUrls: ['./pie.component.css']
})
export class PieComponent implements OnInit {

  fecdia: string; 

  constructor() { }

  ngOnInit(): void {
    const nano = new Date().getFullYear();
    if (nano > 2021) {
      this.fecdia =  '2021 - ' + nano.toString();
    } else {
      this.fecdia = nano.toString();
    }
  }

}
